<common-mojo-expandable-card
  (toggle)="toggleCard($event)"
  [expandable]="expandable"
  [isExpanded]="expanded"
  *ngIf="showCard; else talentPoolView"
>
  <ng-template-outlet *ngTemplateOutlet="skillsContent">
  </ng-template-outlet>

</common-mojo-expandable-card>

<ng-template #talentPoolView>
  <mojo-expandible-card
    [expandable]="expandable"
    (toggle)="toggleCard($event)"
  >
    <ng-template-outlet *ngTemplateOutlet="skillsContent">
    </ng-template-outlet>
  </mojo-expandible-card>
</ng-template>

<ng-template #skillsContent>
  <div
    class="skills-header"
    [ngClass]="{'font-size-talent-pool': !isNotAnonymized && fromTalentPool}"
  >{{header}}</div>
  <div class="skills-list">
    <div class="skills-list-element">
      <mojo-candidate-skill [skills]="displayedSkills"></mojo-candidate-skill>
    </div>
  </div>
</ng-template>
